/**
 * Valid status for a project
 */
export enum ProjectStatus {
  Draft = 'Draft',
  Created = 'Created',
  InProgress = 'In progress',
  Billing = 'Billing',
  Closed = 'Closed',
}
